module.exports = "files/mario.png";